import { MoveableIcon } from "allIcons";
import IconContainer from "./IconContainer";
import { forwardRef } from "react";

const DragElement = forwardRef(({ className, ...props}, ref) => {
  return (
    <>
      <IconContainer className={`cursor-move ${className}`}
      {...props}
      ref={ref}
      >
        <MoveableIcon />
      </IconContainer>
    </>
  );
});

export default DragElement;
